type TicketTranslation = Record<'en' | 'fr' | 'ar', string>;

export const ticketTranslations = {
  Ticket: { en: 'Ticket', fr: 'Ticket', ar: 'تذكرة' },
  Tickets: { en: 'Tickets', fr: 'Tickets', ar: 'التذاكر' },
  TicketsSubtitle: {
    en: 'Create and follow up on your support requests.',
    fr: 'Créez et suivez vos demandes d’assistance.',
    ar: 'أنشئ طلبات الدعم وتابعها.',
  },
  CreateTicket: {
    en: 'Create ticket',
    fr: 'Créer un ticket',
    ar: 'إنشاء تذكرة',
  },
  Creating: { en: 'Creating…', fr: 'Création…', ar: 'جارٍ الإنشاء…' },
  TicketTitle: { en: 'Title', fr: 'Titre', ar: 'العنوان' },
  TicketTitlePlaceholder: {
    en: 'Briefly describe the issue',
    fr: 'Décrivez brièvement le problème',
    ar: 'صف المشكلة باختصار',
  },
  Description: { en: 'Description', fr: 'Description', ar: 'الوصف' },
  Category: { en: 'Category', fr: 'Catégorie', ar: 'الفئة' },
  Priority: { en: 'Priority', fr: 'Priorité', ar: 'الأولوية' },
  FirstMessage: {
    en: 'First message',
    fr: 'Premier message',
    ar: 'الرسالة الأولى',
  },
  DescribeIssue: {
    en: 'Describe what you need help with…',
    fr: 'Décrivez l’aide dont vous avez besoin…',
    ar: 'اشرح ما تحتاج إلى مساعدة بشأنه…',
  },
  Data: { en: 'Data', fr: 'Données', ar: 'البيانات' },
  Technical: { en: 'Technical', fr: 'Technique', ar: 'تقني' },
  Account: { en: 'Account', fr: 'Compte', ar: 'الحساب' },
  Other: { en: 'Other', fr: 'Autre', ar: 'أخرى' },
  Customers: { en: 'Customers', fr: 'Clients', ar: 'العملاء' },
  Call: { en: 'Call', fr: 'Appel', ar: 'مكالمة' },
  Synchronization: {
    en: 'Synchronization',
    fr: 'Synchronisation',
    ar: 'المزامنة',
  },
  NFA: { en: 'NFA', fr: 'NFA', ar: 'NFA' },
  Reports: { en: 'Reports', fr: 'Rapports', ar: 'التقارير' },
  Expenses: { en: 'Expenses', fr: 'Dépenses', ar: 'المصاريف' },
  Invoices: { en: 'Invoices', fr: 'Factures', ar: 'الفواتير' },
  'Double visits': {
    en: 'Double visits',
    fr: 'Visites doubles',
    ar: 'زيارات مزدوجة',
  },
  'Leave balance': {
    en: 'Leave balance',
    fr: 'Solde de congés',
    ar: 'رصيد الإجازات',
  },
  Others: { en: 'Others', fr: 'Autres', ar: 'أخرى' },
  Low: { en: 'Low', fr: 'Faible', ar: 'منخفضة' },
  Medium: { en: 'Medium', fr: 'Moyenne', ar: 'متوسطة' },
  High: { en: 'High', fr: 'Élevée', ar: 'مرتفعة' },
  Urgent: { en: 'Urgent', fr: 'Urgente', ar: 'عاجلة' },
  Open: { en: 'Open', fr: 'Ouvert', ar: 'مفتوحة' },
  InProgress: { en: 'In progress', fr: 'En cours', ar: 'قيد التنفيذ' },
  Closed: { en: 'Closed', fr: 'Fermé', ar: 'مغلقة' },
  Reopened: { en: 'Reopened', fr: 'Rouvert', ar: 'أعيد فتحها' },
  User: { en: 'User', fr: 'Utilisateur', ar: 'المستخدم' },
  Admin: { en: 'Admin', fr: 'Administrateur', ar: 'المشرف' },
  Files: { en: 'Files', fr: 'Fichiers', ar: 'الملفات' },
  AttachFiles: {
    en: 'Attach files',
    fr: 'Joindre des fichiers',
    ar: 'إرفاق ملفات',
  },
  ReplyAttachmentLimits: {
    en: 'Up to 5 images, PDFs or spreadsheets, 1 audio and 1 video; 10 MB each',
    fr: 'Jusqu’à 5 images, PDF ou feuilles de calcul, 1 audio et 1 vidéo ; 10 Mo chacun',
    ar: 'حتى 5 صور أو ملفات PDF أو جداول بيانات وملف صوتي واحد وفيديو واحد؛ 10 ميجابايت لكل ملف',
  },
  Audio: { en: 'Audio', fr: 'Audio', ar: 'صوت' },
  Video: { en: 'Video', fr: 'Vidéo', ar: 'فيديو' },
  AttachmentsOptional: {
    en: 'Attachments (optional)',
    fr: 'Pièces jointes (facultatif)',
    ar: 'المرفقات (اختياري)',
  },
  AttachmentsHelp: {
    en: 'Add supporting files or a voice recording.',
    fr: 'Ajoutez des fichiers ou un enregistrement vocal.',
    ar: 'أضف ملفات داعمة أو تسجيلاً صوتياً.',
  },
  ImagesAndDocuments: {
    en: 'Images, PDF & spreadsheets',
    fr: 'Images, PDF et feuilles de calcul',
    ar: 'الصور وملفات PDF وجداول البيانات',
  },
  ImagesAndDocumentsHelp: {
    en: 'PNG, JPG, GIF, PDF, XLSX or CSV · up to 5 files',
    fr: 'PNG, JPG, GIF, PDF, XLSX ou CSV · jusqu’à 5 fichiers',
    ar: 'PNG أو JPG أو GIF أو PDF أو XLSX أو CSV · حتى 5 ملفات',
  },
  AudioFile: { en: 'Audio file', fr: 'Fichier audio', ar: 'ملف صوتي' },
  AudioFileHelp: {
    en: 'MP3, WAV, OGG, WebM or M4A',
    fr: 'MP3, WAV, OGG, WebM ou M4A',
    ar: 'MP3 أو WAV أو OGG أو WebM أو M4A',
  },
  VideoFile: { en: 'Video file', fr: 'Fichier vidéo', ar: 'ملف فيديو' },
  VideoFileHelp: {
    en: 'MP4, WebM or OGG',
    fr: 'MP4, WebM ou OGG',
    ar: 'MP4 أو WebM أو OGG',
  },
  ChooseFiles: { en: 'Choose', fr: 'Choisir', ar: 'اختيار' },
  ChooseAudio: { en: 'Choose', fr: 'Choisir', ar: 'اختيار' },
  ChooseVideo: { en: 'Choose', fr: 'Choisir', ar: 'اختيار' },
  SelectedUploads: { en: 'selected', fr: 'sélectionné(s)', ar: 'محدد' },
  RecordVoiceHelp: {
    en: 'Record up to 5 minutes',
    fr: 'Enregistrez jusqu’à 5 minutes',
    ar: 'سجّل لمدة تصل إلى 5 دقائق',
  },
  RemoveFile: {
    en: 'Remove file',
    fr: 'Supprimer le fichier',
    ar: 'إزالة الملف',
  },
  Attachment: { en: 'Attachment', fr: 'Pièce jointe', ar: 'مرفق' },
  OpenAttachment: { en: 'Open', fr: 'Ouvrir', ar: 'فتح' },
  AttachmentPreview: {
    en: 'Attachment preview',
    fr: 'Aperçu de la pièce jointe',
    ar: 'معاينة المرفق',
  },
  PreviewAttachment: {
    en: 'Preview attachment',
    fr: 'Prévisualiser la pièce jointe',
    ar: 'معاينة المرفق',
  },
  LoadingAttachmentPreview: {
    en: 'Loading preview…',
    fr: 'Chargement de l’aperçu…',
    ar: 'جارٍ تحميل المعاينة…',
  },
  SpreadsheetSheet: {
    en: 'Sheet',
    fr: 'Feuille',
    ar: 'ورقة',
  },
  SpreadsheetEmptySheet: {
    en: 'This sheet is empty.',
    fr: 'Cette feuille est vide.',
    ar: 'هذه الورقة فارغة.',
  },
  SpreadsheetPreviewTruncated: {
    en: 'Preview limited to the first 500 rows and 50 columns. Download the file to view all data.',
    fr: 'L’aperçu est limité aux 500 premières lignes et 50 premières colonnes. Téléchargez le fichier pour voir toutes les données.',
    ar: 'تقتصر المعاينة على أول 500 صف و50 عمودًا. نزّل الملف لعرض جميع البيانات.',
  },
  ClosePreview: {
    en: 'Close preview',
    fr: 'Fermer l’aperçu',
    ar: 'إغلاق المعاينة',
  },
  AttachmentPreviewFailed: {
    en: 'Unable to preview this attachment.',
    fr: 'Impossible de prévisualiser cette pièce jointe.',
    ar: 'تعذرت معاينة هذا المرفق.',
  },
  Download: { en: 'Download', fr: 'Télécharger', ar: 'تنزيل' },
  RecordVoice: {
    en: 'Record voice',
    fr: 'Enregistrer la voix',
    ar: 'تسجيل صوتي',
  },
  Rerecord: { en: 'Record again', fr: 'Réenregistrer', ar: 'إعادة التسجيل' },
  StopRecording: { en: 'Stop', fr: 'Arrêter', ar: 'إيقاف' },
  RecordingUnsupported: {
    en: 'Audio recording is not supported by this browser.',
    fr: 'L’enregistrement audio n’est pas pris en charge par ce navigateur.',
    ar: 'هذا المتصفح لا يدعم التسجيل الصوتي.',
  },
  RecordingInterrupted: {
    en: 'Recording was interrupted.',
    fr: 'L’enregistrement a été interrompu.',
    ar: 'تم إيقاف التسجيل.',
  },
  MicrophoneUnavailable: {
    en: 'Microphone permission was denied or unavailable.',
    fr: 'Le microphone est indisponible ou son accès a été refusé.',
    ar: 'الميكروفون غير متاح أو تم رفض الإذن.',
  },
  EmptyRecording: {
    en: 'No audio was recorded.',
    fr: 'Aucun son enregistré.',
    ar: 'لم يتم تسجيل صوت.',
  },
  FileTooLarge: {
    en: 'The file exceeds 10 MB.',
    fr: 'Le fichier dépasse 10 Mo.',
    ar: 'يتجاوز الملف 10 ميجابايت.',
  },
  TicketFileTooLarge: {
    en: 'Each file must be 10 MB or smaller.',
    fr: 'Chaque fichier doit faire 10 Mo ou moins.',
    ar: 'يجب ألا يتجاوز حجم كل ملف 10 ميجابايت.',
  },
  TicketUnsupportedFile: {
    en: 'Choose a supported image, PDF, XLSX, CSV, audio, or video file.',
    fr: 'Choisissez une image, un PDF, un fichier XLSX, CSV, audio ou vidéo pris en charge.',
    ar: 'اختر صورة أو ملف PDF أو XLSX أو CSV أو ملفًا صوتيًا أو فيديو مدعومًا.',
  },
  TicketAttachmentLimit: {
    en: 'You can attach up to 5 images, PDFs, or spreadsheets.',
    fr: 'Vous pouvez joindre jusqu’à 5 images, PDF ou feuilles de calcul.',
    ar: 'يمكنك إرفاق ما يصل إلى 5 صور أو ملفات PDF أو جداول بيانات.',
  },
  TicketAudioLimit: {
    en: 'You can add one audio file or voice recording per reply.',
    fr: 'Vous pouvez ajouter un fichier audio ou un enregistrement vocal par réponse.',
    ar: 'يمكنك إضافة ملف صوتي واحد أو تسجيل صوتي واحد لكل رد.',
  },
  TicketVideoLimit: {
    en: 'You can add one video file per reply.',
    fr: 'Vous pouvez ajouter un fichier vidéo par réponse.',
    ar: 'يمكنك إضافة ملف فيديو واحد لكل رد.',
  },
  TicketCreated: {
    en: 'Ticket created successfully.',
    fr: 'Ticket créé avec succès.',
    ar: 'تم إنشاء التذكرة بنجاح.',
  },
  TicketCreateFailed: {
    en: 'Failed to create ticket.',
    fr: 'Échec de la création du ticket.',
    ar: 'فشل إنشاء التذكرة.',
  },
  TicketReplyFailed: {
    en: 'Failed to send reply.',
    fr: 'Échec de l’envoi de la réponse.',
    ar: 'فشل إرسال الرد.',
  },
  TicketLoadFailed: {
    en: 'Failed to load ticket.',
    fr: 'Échec du chargement du ticket.',
    ar: 'فشل تحميل التذكرة.',
  },
  LoadingConversation: {
    en: 'Loading conversation…',
    fr: 'Chargement de la conversation…',
    ar: 'جارٍ تحميل المحادثة…',
  },
  NoTicketDescription: {
    en: 'No description provided.',
    fr: 'Aucune description.',
    ar: 'لا يوجد وصف.',
  },
  TicketPollingRetry: {
    en: 'Live updates are temporarily unavailable. Retrying…',
    fr: 'Les mises à jour sont temporairement indisponibles. Nouvelle tentative…',
    ar: 'التحديثات المباشرة غير متاحة مؤقتًا. جارٍ إعادة المحاولة…',
  },
  NoMessagesYet: {
    en: 'No messages yet.',
    fr: 'Aucun message.',
    ar: 'لا توجد رسائل بعد.',
  },
  SeeMore: {
    en: 'See more',
    fr: 'Voir plus',
    ar: 'عرض المزيد',
  },
  SeeLess: {
    en: 'See less',
    fr: 'Voir moins',
    ar: 'عرض أقل',
  },
  TicketClosedMessage: {
    en: 'This ticket is closed. An administrator must reopen it before you can reply.',
    fr: 'Ce ticket est fermé. Un administrateur doit le rouvrir avant votre réponse.',
    ar: 'هذه التذكرة مغلقة. يجب على المشرف إعادة فتحها قبل الرد.',
  },
  WriteReply: {
    en: 'Write a reply…',
    fr: 'Écrire une réponse…',
    ar: 'اكتب ردًا…',
  },
  Sent: { en: 'Sent', fr: 'Envoyé', ar: 'تم الإرسال' },
  Read: { en: 'Read', fr: 'Lu', ar: 'تمت القراءة' },
  Send: { en: 'Send', fr: 'Envoyer', ar: 'إرسال' },
  Sending: { en: 'Sending…', fr: 'Envoi…', ar: 'جارٍ الإرسال…' },
} satisfies Record<string, TicketTranslation>;
